export const LocationSelect = 'LocationSelect'
export const LocationSelectBegin = 'LocationSelectBegin'
export const LocationSelectCancel = 'LocationSelectCancel'
export const LocationSelectClick = 'LocationSelectClick'
export const LocationCloseToMeClick = 'near_me_click'
